const apiUrl = "https://llama3.com/api/v1"

export {
  apiUrl
};